export class LoadDashboardKpis {
  static readonly type = '[Dashboard] Load KPIs';
  constructor(public branchId?: string) {}
}
